var jQuery = require('jquery');
var Rx = require('ub_wrapped/rx');
var ubBanzai = require('ub/control/banzai-features');

var ajaxAsObservable = function(settings) {
  if (ubBanzai.features.isSandboxEnabled()) {
    return new Rx.AnonymousObservable(function(observer) {
      observer.onNext({data: {}, textStatus: {}, jqXHR: {}});
      observer.onCompleted();
    });
  }

  return new Rx.AnonymousObservable(function(observer) {
    var internalSettings = {
      success: function(data, textStatus, jqXHR) {
        observer.onNext({ data: data, textStatus: textStatus, jqXHR: jqXHR });
        observer.onCompleted();
      },
      error: function(jqXHR, textStatus, errorThrown) {
        observer.onError({jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
      }
    };
    jQuery.extend(true, internalSettings, settings);
    var request = jQuery.ajax(internalSettings);

    return function() {
      if (request.readyState !== 4) {
        request.abort();
      }
    };
  });
};

module.exports = ajaxAsObservable;



// WEBPACK FOOTER //
// ./src/control/ajax-as-observable.js